export const MOBILE_MEDIA_QUERY = '(max-width: 599px)';

/**
 * Ниже десктопа ui-kit: телефоны и окно 600–899.95px.
 * 900px уже десктоп, как theme.breakpoints.down('mobile').
 */
export const TABLET_MEDIA_QUERY = '(max-width: 899.95px)';

export const SMALL_PC_QUERY = '(max-width: 1200px)';
